import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NewStudyModal from './NewStudyModal';

const NewStudy: React.FC = () => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="contained" onClick={handleOpen}>
        {t('studies.newStudy')}
      </Button>
      {open && <NewStudyModal handleClose={handleClose} />}
    </>
  );
};

export default NewStudy;
